import { LegalPage } from "./legal/LegalPage";
import TermsAndConditonsDocument from "./dynamic/TermsAndConditons";

export default function TermsAndConditionsComponent() {
  return (
    <LegalPage path="/termsandconditions">
      <TermsAndConditonsDocument />
    </LegalPage>
  );
}
